import { useUser } from '@/shared/hooks/useAuth';
import { EmployeeDashboard } from './pages/EmployeeDashboard';
import { OperationalDashboard } from './pages/OperationalDashboard';
import { AdminDashboard } from './pages/AdminDashboard';
import { SuperAdminDashboard } from './pages/SuperAdminDashboard';

export function DashboardPage() {
  const user = useUser();

  if (user?.role === 'superadmin') {
    return <SuperAdminDashboard />;
  }

  if (user?.role === 'admin') {
    return <AdminDashboard />;
  }

  if (user?.role === 'employee') {
    return <EmployeeDashboard />;
  }

  // Manager, Team Lead, BDE, Developer → shared operational dashboard
  // (reuses employee widgets backed by non-admin endpoints).
  return <OperationalDashboard />;
}

